import { Inbox } from "lucide-react";

export type EmptyProps = {
  title: string;
  description?: string;
  actions: { label: string; onClick(): void }[];
};

export function EmptyState({ title, description, actions }: EmptyProps) {
  return (
    <div className="text-center py-5">
      <Inbox size={48} className="text-muted mb-3" aria-hidden="true" />
      <h2 className="h5">{title}</h2>
      {description && <p className="text-muted">{description}</p>}
      <div className="d-flex flex-wrap justify-content-center gap-2">
        {actions.map((a, i) => (
          <button
            key={a.label}
            type="button"
            className={`btn ${i === 0 ? "btn-primary" : "btn-outline-secondary"}`}
            onClick={a.onClick}
          >
            {a.label}
          </button>
        ))}
      </div>
    </div>
  );
}
